import KeyPager from './KeyPager';
import type { KeyPagerProps } from './KeyPager';

type ListingEligibility = { isEligible?: boolean; title?: string | null; description?: string | null };

const ListingEligibility = ({ isEligible = true, title = '', description = '' }: ListingEligibility = {}) => ({
  isEligible: Boolean(isEligible),
  title: String(title),
  description: String(description),
});

type ListingInputs = {
  aliasEncoded?: string;
  city?: string;
  country?: string;
  eligibility?: ListingEligibility;
  listingId?: string;
  message?: string;
  primaryPhotoUrl?: string;
  priority?: string;
  state?: string;
  street?: string;
  unit?: string;
  urlPath?: string;
  zip?: string;
};

const Listing = ({
  aliasEncoded = '',
  city = '',
  country = '',
  eligibility = {},
  listingId = '',
  message = '',
  primaryPhotoUrl = '',
  priority = '',
  state = '',
  street = '',
  unit = '',
  urlPath = '',
  zip = '',
}: ListingInputs = {}) => ({
  aliasEncoded: String(aliasEncoded),
  city: String(city),
  country: String(country),
  eligibility: ListingEligibility(eligibility),
  listingId: String(listingId),
  message: String(message),
  primaryPhotoUrl: String(primaryPhotoUrl),
  priority: String(priority),
  state: String(state),
  street: String(street),
  unit: String(unit),
  urlPath: String(urlPath),
  zip: String(zip),
});

export type ListingProps = ReturnType<typeof Listing>;

type ListingCountProps = {
  total?: number;
  active?: number;
  inactive?: number;
};

const ListingCount = ({ total = 0, active = 0, inactive = 0 }: ListingCountProps = {}) => ({
  total,
  active,
  inactive,
});

export type ListingIntInputs = {
  isPartialResponse?: boolean;
  listings?: Array<ListingProps>;
  listingCount?: ListingCountProps;
  pager?: KeyPagerProps;
};

const ListingInt = ({
  isPartialResponse = false,
  listings = [],
  listingCount = {},
  pager = {},
}: ListingIntInputs = {}) => ({
  isPartialResponse: String(isPartialResponse),
  listings: listings.map((item) => Listing(item)),
  listingCount: ListingCount(listingCount),
  pager: KeyPager(pager),
});

export default ListingInt;

export type ListingIntProps = ReturnType<typeof ListingInt>;
